var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.955 160.933C163.955 162.596 162.595 163.956 160.933 163.956H141.667V170H160.933C165.92 170 170 165.92 170 160.933V141.667H163.955V160.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.933 6.04444C162.595 6.04444 163.955 7.40444 163.955 9.06667V28.3333H170V9.06667C170 4.08 165.92 0 160.933 0H141.667V6.04444H160.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06667 163.956C7.40444 163.956 6.04444 162.596 6.04444 160.933V141.667H0V160.933C0 165.92 4.08 170 9.06667 170H28.3333V163.956H9.06667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04444 9.06667C6.04444 7.40444 7.40444 6.04444 9.06667 6.04444H28.3333V0H9.06667C4.08 0 0 4.08 0 9.06667V28.3333H6.04444V9.06667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3734 70.8533C79.5156 70.8533 73.1689 77.2 73.1689 85.0578C73.1689 92.9156 79.5156 99.2622 87.3734 99.2622C95.2312 99.2622 101.578 92.9156 101.578 85.0578C101.578 77.2 95.2312 70.8533 87.3734 70.8533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.022 57.2533H105.053L102.182 50.3022C101.2 48.0356 98.48 45.92 95.9867 45.92H78.3822C75.9644 45.92 73.1689 48.0356 72.2622 50.3022L69.3911 57.2533H46.2711C43.8533 57.2533 40 58.84 40 61.2578V111.276C40 113.693 43.8533 116.036 46.2711 116.036H128.022C130.44 116.036 134.444 113.693 134.444 111.276V61.2578C134.444 58.84 130.516 57.2533 128.022 57.2533ZM87.3733 107.196C75.1333 107.196 65.3111 97.2978 65.3111 85.0578C65.3111 72.8933 75.2089 62.9955 87.3733 62.9955C99.5378 62.9955 109.436 72.8933 109.436 85.0578C109.436 97.2978 99.5378 107.196 87.3733 107.196ZM121.524 74.7822C118.276 74.7822 115.707 72.1378 115.707 68.9644C115.707 65.7155 118.351 63.1467 121.524 63.1467C124.698 63.1467 127.342 65.7911 127.342 68.9644C127.418 72.2133 124.773 74.7822 121.524 74.7822Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 170,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.e0cb74c83fdc5f50915a0a8bf6abbadb.svg";
export { ForwardRef as ReactComponent };